import React from "react";
import { Center } from "@mantine/core";
import ServerRenderedBlock, { hasServerRenderedBlock } from "./ServerRenderedBlock";

/**
 * The Rizful logo at the top of a tool page. Rails renders it (layouts/_tool_shell) so it
 * shows before React mounts; this adopts that one, or renders its own on pages without it.
 */
const ToolLogo: React.FC = () =>
  hasServerRenderedBlock("ssr-tool-logo") ? (
    <ServerRenderedBlock id="ssr-tool-logo" />
  ) : (
    <Center>
      <a href="/">
        <img
          src="https://daxwktpz4hkwd.cloudfront.net/logos/rizful-logo-mobile.png"
          alt="Rizful"
          style={{ height: "32px", width: "auto", cursor: "pointer" }}
        />
      </a>
    </Center>
  );

export default ToolLogo;
